<p-toast position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-5">
        <lib-page-header page-title="ADIANTAMENTOS"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/business-and-finance1.png">
        </lib-page-header>
      </div>
      <div class="col-7">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a [routerLink]="['/adiantamentos', 'relatorios']" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/filter.png" alt="imprimir" title="Relatórios" height="20" width="20">
        </a>
        <button data-toggle="modal" data-target="#dialogImprimir"
          class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/printer.png" alt="imprimir" title="Imprimir processo adiantamento" height="22"
            width="22">
        </button>
        <button data-toggle="modal" data-target="#dialogEtiqueta"
          class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/slide_notes_master.png" alt="etiqueta" title="Etiquetas processo adiantamento"
            height="22" width="22">
        </button>
        <a [routerLink]="['/adiantamentos', 'novo']" *ngIf="podeIncluir()"
          class="btn btn-outline-success btn-sm float-right mr-3">Novo adiantamento</a>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <em class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></em>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-12 table-responsive">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col" class="text-center">Processo Nº</th>
              <th scope="col" class="text-center">Empenho Nº</th>
              <th scope="col" class="text-center">Data Início</th>
              <th scope="col">Vencimento</th>
              <th scope="col">Beneficiário</th>
              <th scope="col"></th>
              <th scope="col" class="text-right">Valor</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <th scope="row" class="text-center">{{("00000" + item.numero).slice(-5) }}</th>
              <th scope="row" class="text-center">{{("00000" + item.empenho.numero).slice(-5) }}</th>
              <td class="text-center">{{item.data_adiantamento | date:'dd/MM/yyyy':'GMT'}}</td>
              <td class="text-center">{{item.data_vencimento | date:'dd/MM/yyyy':'GMT'}}</td>
              <td>{{item.beneficiario}}</td>
              <td>
                <span *ngIf="item.data_prestacao" class="badge badge-success">
                  <img src="assets/img/global/tick.png" alt="check" height="16" width="16">
                  Prestado conta
                </span>
                <span *ngIf="!item.data_prestacao" class="badge badge-warning">
                  Aberto
                </span>
              </td>
              <td class="text-right">
                {{item.valor_adiantado | number:'1.2-2'}}
              </td>
              <td class="text-right" style="min-width: 120px">
                <button [routerLink]="['/adiantamentos', item.id, 'visualizar']" routerLinkActive="router-link-active"
                  *ngIf="podeIncluir() && podeAlterar(item.data_adiantamento)"
                  class="btn btn-sm btn-outline-secondary mr-2">
                  <img src="assets/img/global/zoom.png" alt="visualizar" height="16" width="16">
                </button>
                <button [routerLink]="['/adiantamentos', item.id, 'editar']" routerLinkActive="router-link-active"
                  *ngIf="podeIncluir() && podeAlterar(item.data_adiantamento)"
                  class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                </button>
                <button [routerLink]="['/adiantamentos', item.id, 'visualizar']" routerLinkActive="router-link-active"
                  *ngIf="!podeIncluir() || !podeAlterar(item.data_adiantamento)"
                  class="btn btn-sm btn-outline-secondary mr-2" title="Visualizar">
                  <img src="assets/img/global/zoom.png" alt="" height="16" width="16">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>

<lib-nota-adiantamento-dlg [login]="login"></lib-nota-adiantamento-dlg>
<lib-etiqueta-protocolo-dlg [login]="login"></lib-etiqueta-protocolo-dlg>